<template>
  <div class="about-page">
    <div v-if="aboutSection.found" class="about-layout">
      <aside class="about-toc" aria-label="本页导航">
        <p class="about-toc-title">导航</p>
        <el-anchor container=".about-content" :offset="20" :bound="12" :duration="300" :select-scroll-top="true">
          <el-anchor-link v-for="heading in aboutHeadings" :key="heading.id" :href="`#${heading.id}`"
            :title="heading.title" />
        </el-anchor>
      </aside>

      <article class="about-content markdown-body" v-html="aboutHtml" />
    </div>

    <el-backtop v-if="aboutSection.found" target=".about-content" :right="32" :bottom="32" :visibility-height="240" />

    <!-- about:start --><!-- about:end -->
    <el-alert v-else title="项目介绍内容暂不可用" description="请检查 README.md 中的 about:start 与 about:end 标记。" type="warning"
      :closable="false" show-icon />
  </div>
</template>
<script setup lang="ts">
import { APP_BRAND } from '~/enums'
import projectReadme from '~/README.md?raw'
import { addMarkdownHeadingIds, extractMarkdownHeadings, extractMarkdownSection } from '~/utils/markdown-section'
import { renderMarkdown } from '~/utils/index'

// 页面元信息配置
definePageMeta({
  title: `关于 ${APP_BRAND.PRODUCT_NAME}`
})

// SEO 配置
useSeoMeta({
  title: `关于 ${APP_BRAND.PRODUCT_NAME}`,
  description: APP_BRAND.META_DESCRIPTION,
})

// 提取关于页面内容并渲染为 HTML
const aboutSection = extractMarkdownSection(projectReadme, 'about')
const aboutHeadings = computed(() => extractMarkdownHeadings(aboutSection.content))
const aboutHtml = computed(() => addMarkdownHeadingIds(
  renderMarkdown(aboutSection.content),
  aboutHeadings.value,
))
</script>


<style scoped>
.about-page {
  height: 86vh;
  padding: 20px 24px 0;
}

.about-layout {
  display: grid;
  grid-template-columns: 180px minmax(0, 1fr);
  gap: 24px;
  max-width: 1180px;
  height: 82vh;
  margin: 0 auto;
}

.about-toc {
  align-self: start;
  padding: 18px 16px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background: #fff;
}

.about-toc-title {
  margin: 0 0 12px;
  color: #303133;
  font-size: 14px;
  font-weight: 600;
}

.about-toc :deep(.el-anchor) {
  background: transparent;
}

.about-content {
  width: 100%;
  height: 100%;
  margin: 0;
  overflow-y: auto;
  padding: 30px 40px;
  box-sizing: border-box;
  color: #303133;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgb(0 0 0 / 4%);
}

.about-content :deep(h1) {
  margin-top: 0;
  color: #1f2937;
  font-size: 32px;
}

.about-content :deep(h2) {
  margin-top: 40px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e4e7ed;
  color: #1f2937;
  font-size: 24px;
}

.about-content :deep(h3) {
  margin-top: 26px;
  color: #303133;
  font-size: 18px;
}

.about-content :deep(p),
.about-content :deep(li) {
  color: #4b5563;
  line-height: 1.8;
}

.about-content :deep(img) {
  display: block;
  margin: 20px auto 28px;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
}

@media (max-width: 767px) {
  .about-page {
    padding: 16px 16px 0;
  }

  .about-layout {
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
  }

  .about-toc {
    padding: 12px 16px;
  }

  .about-content {
    padding: 24px 20px;
  }

  .about-content :deep(h1) {
    font-size: 26px;
  }

  .about-content :deep(h2) {
    font-size: 21px;
  }
}
</style>
